import BulkEditModal from './BulkEditModal';

export default BulkEditModal;
